import { useEffect, useState } from 'react';

import { DateInputWithConfirm, RadioOptionsWithConfirm, getStringFromDate } from 'shared-components';

import { IDate, IQuestion, ITravelStatus } from '../../../../../../../../../types';
import { validateDate } from '../../../../../../../../../utilities/validateDate';

enum TravelPlanSelection {
  YES = 'Yes',
  DONT_HAVE = "Yes but I don't have it yet",
  NO = 'No'
}

interface IProps {
  setComplete: (status: boolean) => void;
  additionalAnswers: {
    setAnswers: (data: Omit<ITravelStatus, 'status'>) => void;
  };
}
export const Booked = (props: IProps) => {
  const {
    setComplete,
    additionalAnswers: { setAnswers }
  } = props;

  const [selection, setSelection] = useState('');
  const [bookedDateError, setBookedDateError] = useState('');
  const [dateState, setDateState] = useState<IDate>({
    DD: '',
    MM: '',
    YYYY: ''
  });

  useEffect(() => {
    if (
      Object.values(TravelPlanSelection).includes(selection as TravelPlanSelection) &&
      Boolean(!bookedDateError.length && dateState.DD?.length && dateState.MM?.length && dateState.YYYY?.length === 4)
    ) {
      const newDate = getStringFromDate(dateState);
      setAnswers({
        haveTravelTicket: selection,
        bookedDate: newDate
      });

      setComplete(true);
    } else {
      setComplete(false);
    }
  }, [selection, dateState, setAnswers, setComplete, bookedDateError]);

  return (
    <>
      <DateInputWithConfirm
        id="arrived"
        value={dateState}
        errorText={bookedDateError}
        label="When are you arriving in the UK?"
        subText="Please enter the arrival date as stated on your travel booking"
        onChangeDD={(evt: any) => {
          const value = evt.currentTarget.value;
          setDateState(prevValue => ({ ...prevValue, DD: value }));
        }}
        onChangeMM={(evt: any) => {
          const value = evt.currentTarget.value;
          setDateState(prevValue => ({ ...prevValue, MM: value }));
        }}
        onChangeYY={(evt: any) => {
          const value = evt.currentTarget.value;
          if (value.length === 4) {
            setBookedDateError(
              validateDate({
                ...dateState,
                YYYY: value
              })
            );
          }
          setDateState(prevValue => ({ ...prevValue, YYYY: value }));
        }}
        onBlur={() => setBookedDateError(validateDate(dateState))}
      />

      <RadioOptionsWithConfirm
        label={`Did you have a new travel ticket or booking document for this change of travel plans?`}
        questions={[
          {
            char: '1',
            label: TravelPlanSelection.YES,
            selected: selection === TravelPlanSelection.YES
          },
          {
            char: '2',
            label: TravelPlanSelection.DONT_HAVE,
            selected: selection === TravelPlanSelection.DONT_HAVE
          },
          {
            char: '3',
            label: TravelPlanSelection.NO,
            selected: selection === TravelPlanSelection.NO
          }
        ]}
        onClick={(question: IQuestion) => {
          setSelection(question.label);
          return true;
        }}
      />
    </>
  );
};
